<script lang="ts">
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';
  import TemperamentsDemo from 'exercises/src/uTheory.Notation/temperaments/TemperamentsDemo.svelte';
</script>

<PageTitle
  title="Tuning Systems Synthesizer"
  description={'Play chords and melodies in equal temperament, just intonation or pythagorean tuning using a midi keyboard or a mouse.'}
  seoImageUrl="https://utheory.com/assets/tuning-systems/tuning-systems-social.jpg"
  seoImageHeight={1080}
  seoImageWidth={1080}
  seoImageAlt="A radio list of available tuning systems, Just Intonation (Automatic) - Root Note F is selected from a list of Equal Temperament, Just Intonation (Manual), Just Intonation (Automatic) and Pythagorean Tuning (Manual). A piano keyboard is shown with F-A-C highlighted in blue. Below the keyboard, two buttons: 'All Notes Off' and 'Mute' appear. At the top right, the uTheory logo (a white uT on a green background)."
/>

<div class="unreset text-gray my-4">
  <p>
    How do chords sound in different tuning systems? What's the difference between just intonation
    and equal temperament tuning?
  </p>
  <p>
    Hear for yourself by playing on the keyboard below and changing tuning systems. If you have a
    midi keyboard connected to your computer, and you're using Chrome or Firefox, you can use that,
    too.
  </p>
</div>
<TemperamentsDemo />
